import React from 'react';

// テーブルtr属性　曜日作成
const ListItem = (props) => {
    return <td>{props.week}</td>;
  }
  
  const WeekList = (props) => {
    const weekdays = props.weekdays;
    const listItems = weekdays.map((day,index) =>
      <ListItem key={index} week={day} />
    );
    return (
      <tr>
        {listItems}
      </tr>
    );
  };  

export default WeekList;